module.exports = __webpack_public_path__ + "static/media/Bluetooth.svg.2aac77d8.png";